import mainFeatureSlideshow from './mainFeatureSlideshow';

export default function vimeoFeature() {
  const widgetName = 'vimeoFeature';
  const widgetOpts = vimeoFeatureOpts;

  // Video Seetings
  const videoSettings = {
    controls: false, // if false, autoplay is set to true by default
    autoplay: true,
    loop: true,
  };

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createVimeoFeature(data.items[0]);
      } else {
        $('#vimeoFeature').remove();
        mainFeatureSlideshow();
      }
    },
  });

  function createVimeoFeature(slide) {
    const videoConfig = updateAutoplay(videoSettings);

    $(`#${widgetName}`).find('.card-widget-title').remove();
    $(`#${widgetName}`).find('.buttonwrap').remove();

    let vimeoURLAttr = $(slide.Description).find('iframe').attr('src');
    vimeoURLAttr = `${vimeoURLAttr}${videoConfig}`;
    $(`#${widgetName}`).find('.card-widget-description iframe').attr('src', vimeoURLAttr);
  }
}

function updateAutoplay(videoSettings) {
  let attrs = '';
  if (videoSettings.controls) {
    attrs += videoSettings.controls ? '&controls=1' : '&controls=0';
    attrs += videoSettings.autoplay ? '&autoplay=1' : '&autoplay=0';
    attrs += videoSettings.loop ? '&loop=1' : '&loop=0';
  } else {
    attrs += '&controls=0&autoplay=1&autoplay=0';
  }

  return attrs;
}
